import DateUtils from 'quasar/src/utils/date/date.js';
export class DateFormatter {
    static destinationTimeZone = 'Europe/Warsaw';
    static getDateFormat() {
        return 'DD-MM-YYYY';
    }
    static getDateTimeFormat() {
        return 'DD-MM-YYYY HH:mm';
    }
    static getTimeFormat() {
        return 'HH:mm';
    }
    static toDateString(date) {
        return DateUtils.formatDate(date, DateFormatter.getDateFormat());
    }
    static fromDateString(date) {
        return DateUtils.extractDate(date, DateFormatter.getDateFormat());
    }
    static toTimeString(date) {
        return DateUtils.formatDate(date, this.getTimeFormat());
    }
    static fromDateTimeString(dateTime) {
        return DateUtils.extractDate(dateTime, DateFormatter.getDateTimeFormat());
    }
    static addMonths(date, months) {
        if (!date)
            return new Date();
        const input = date instanceof Date ? new Date(date.getTime()) : new Date(date);
        if (isNaN(input.getTime()))
            return new Date();
        const year = input.getFullYear();
        const monthIndex = input.getMonth() + months;
        const target = new Date(year, monthIndex, 1);
        const daysInTargetMonth = new Date(target.getFullYear(), target.getMonth() + 1, 0).getDate();
        const day = Math.min(input.getDate(), daysInTargetMonth);
        return new Date(target.getFullYear(), target.getMonth(), day);
    }
    static changeTimeZone(date, timeZone) {
        const longOffsetFormatter = new Intl.DateTimeFormat('en-US', {
            timeZone: timeZone,
            timeZoneName: 'longOffset',
        });
        const longOffsetString = longOffsetFormatter.format(date);
        const gmtOffset = longOffsetString.split('GMT')[1];
        return new Date(`${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}T${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}:00.000${gmtOffset}`);
    }
}
